import { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Breadcrumbs from "../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { Href } from "../../utils/Constant";
import IPTabContent from "./IPTabContent";

function IPSettingsTab() {
  const { t } = useTranslation();
  const [basicTab, setBasicTab] = useState<string>("1");
  return (
    <div>
      <Container fluid>
        <Breadcrumbs
          mainTitle={t("IPManagement")}
          parent={t("MasterSetings")}
        />
        <Col xl="12">
          <Card>
            <CardBody>
              <Nav tabs className="border-tab border-0 mb-0 nav-warning">
                <NavItem>
                  <NavLink
                    href={Href}
                    className={`nav-border pt-0 txt-warning nav-warning ${
                      basicTab === "1" ? "active" : ""
                    }`}
                    onClick={() => setBasicTab("1")}
                  >
                    <i className="icofont icofont-man-in-glasses"></i>
                    {t("WhiteList")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href={Href}
                    className={`nav-border txt-warning nav-warning ${
                      basicTab === "2" ? "active" : ""
                    }`}
                    onClick={() => setBasicTab("2")}
                  >
                    <i className="icofont icofont-file-document"></i>
                    {t("BlackList")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href={Href}
                    className={`nav-border txt-warning nav-warning ${
                      basicTab === "3" ? "active" : ""
                    }`}
                    onClick={() => setBasicTab("3")}
                  >
                    <i className="icofont icofont-star"></i>
                    {t("nonList")}
                  </NavLink>
                </NavItem>
              </Nav>
              <IPTabContent basicTab={basicTab} />
            </CardBody>
          </Card>
        </Col>
      </Container>
    </div>
  );
}

export default IPSettingsTab;
